@if (isHairFrontPhoto || isHairTopPhoto) {
  <cs-icon class="tw-absolute tw-left-6 tw-top-4 tw-h-6 tw-w-6 tw-text-black tw-z-10"
    [iconName]="'arrow_back'"
  (click)="back()"></cs-icon>
  <main class="tw-grid tw-place-content-center tw-flex-col tw-h-full tw-relative tw-pb-[160px] tw-px-9">
    <section class="tw-overflow-hidden">
      <swiper #slider
        class="tw-pb-14"
        [config]="carouselConfig">
        @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
          <div *swiperSlide
            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
            @if (isHairFrontPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_instruction_male_1_new.png"
                alt="male hair instruction">
            }
            @if (isHairTopPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_top_instruction_male_1.png"
                alt="male hair top instruction">
            }
            <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500"
              i18n="@@holdYourHairBack">
                          Hold your <br>hair back</h2>
            </div>
          }
          @if (user?.get('Gender') === appConfig.Shared.Gender.FEMALE && isHairTopPhoto) {
            <div *swiperSlide
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
              <img class="tw-rounded-5" src="https://cdn.cureskin.com/app/img/hair_instruction_female_1.png" alt="hair instruction">
              <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500" i18n="@@centerPartitionWithHair">Center partition with hair behind shoulder</h2>
            </div>
          }
          <div *swiperSlide
            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
            @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && isHairFrontPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_instruction_male_2_new.png"
                alt="hair instruction">
            }
            @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && isHairTopPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_top_instruction_male_2.png"
                alt="hair top instruction">
            }
            @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE && isHairFrontPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_instruction_female_2.png"
                alt="hair instruction female">
            }
            @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE && isHairTopPhoto) {
              <img class="tw-rounded-5"
                src="https://cdn.cureskin.com/app/img/hair_top_instruction_female_2.png"
                alt="hair top instruction">
            }
            @if (isHairFrontPhoto) {
              <h2
                class="tw-font-body tw-text-black tw-text-center tw-text-500"
                i18n="@@holdPhoneInFront">
                              Hold phone in front <br>of your face</h2>
              }
              @if (isHairTopPhoto) {
                <h2
                  class="tw-font-body tw-text-black tw-text-center tw-text-500"
                  i18n="@@tiltYourHeadTowardsCamera">Tilt your head <br> towards camera</h2>
                }
              </div>
              @if ((user?.get('Gender') !== appConfig.Shared.Gender.MALE) && !isHairTopPhoto) {
                <div *swiperSlide
                  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                  @if (user?.get('Gender') === appConfig.Shared.Gender.MALE  && isHairFrontPhoto) {
                    <img class="tw-rounded-5"
                      src="https://cdn.cureskin.com/app/img/hair_instruction_male_3_new.png"
                      alt="hair instruction">
                  }
                  @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                    <img class="tw-rounded-5"
                      src="https://cdn.cureskin.com/app/img/hair_instruction_female_3.png"
                      alt="hair instruction">
                  }
                  <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500" i18n="@@makeCenterPartitionAndFitOval">
                                   Make center partition <br> & fit your face in oval
                              </h2>
                </div>
              }
              @if (!isHairTopPhoto) {
                <div *swiperSlide
                  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                  <div class="tw-relative">
                    @if (user?.get('Gender') === appConfig.Shared.Gender.MALE  && isHairFrontPhoto) {
                      <img class="tw-rounded-5"
                        src="https://cdn.cureskin.com/app/img/hair_instruction_male_4.png"
                        alt="hair instruction">
                    }
                    @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                      <img class="tw-rounded-5"
                        src="https://cdn.cureskin.com/app/img/hair_instruction_female_4.png"
                        alt="female hair instruction">
                    }
                    <div
                      class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-bottom-4">
                      <div
                        class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                        <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                        [iconName]="'close'"></cs-icon>
                      </div>
                      <div
                        class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                        <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                        [iconName]="'done'"></cs-icon>
                      </div>
                    </div>
                  </div>
                  <h2 class="tw-font-body tw-text-700 tw-text-black tw-text-center"
                    i18n="@@removeGlasses">
                                   Remove glasses</h2>
                </div>
              }
            </swiper>
          </section>
          <footer
            class="tw-absolute tw-bottom-0 tw-right-0 tw-left-0 tw-min-h-[160px] tw-flex tw-flex-col tw-gap-4 tw-px-6 tw-py-7">
            @if (showNextCta()) {
              <button csButton="outlined"
                type="button"
                class="tw-w-full"
                (click)="slider?.swiperRef.slideNext()"
                i18n="@@next">Next
               </button>
            }
            @if (showTakePhotoCta()) {
              <button csButton
                type="button"
                class="tw-w-full"
              (click)="takePhoto()"><span i18n="@@takePhoto">Take Photo</span></button>
            }
            @if (true) {
              <button csButton="outlined"
                type="button"
                class="tw-w-full"
                (click)="uploadFromGallery()"
                i18n="@@uploadPhoto">Upload Photo</button>
            }
            <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-500 tw-mb-0.5"
              [iconName]="'lock-solid'"></cs-icon>
              <span class="tw-font-body tw-text-100 tw-text-gray-500"
              i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
            </div>
          </footer>
        </main>
      }

      @if (!(isHairFrontPhoto || isHairTopPhoto)) {
        <cs-icon class="tw-absolute tw-left-6 tw-top-4 tw-h-6 tw-w-6 tw-text-black tw-z-10"
          [iconName]="'arrow_back'"
        (click)="back()"></cs-icon>
        <main class="tw-grid tw-place-content-center tw-flex-col tw-h-full tw-relative tw-pb-[160px] tw-px-9">
          <section class="tw-overflow-hidden">
            <swiper #slider
              class="tw-pb-14"
              [config]="carouselConfig">
              <div *swiperSlide
                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && isFrontFacePhoto) {
                  <img class="tw-rounded-5"
                    src="https://cdn.cureskin.com/app/img/hair_instruction_male_2.png"
                    alt="hair male instruction">
                }
                @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && isSideFacePhoto) {
                  <img class="tw-rounded-5"
                    src="https://cdn.cureskin.com/app/img/face_side_instruction_male_1.png"
                    alt="face male instruction">
                }
                @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE && isFrontFacePhoto) {
                  <img class="tw-rounded-5"
                    src="https://cdn.cureskin.com/app/img/hair_instruction_female_2.png"
                    alt="face female instruction">
                }
                @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE && isSideFacePhoto) {
                  <img class="tw-rounded-5"
                    src="https://cdn.cureskin.com/app/img/face_side_instruction_female_1.png"
                    alt="face side instruction">
                }
                @if (isFrontFacePhoto) {
                  <h2
                    class="tw-font-body tw-text-black tw-text-center tw-text-500"
                    i18n="@@holdPhoneInFront">
                              Hold phone in front <br>of your face</h2>
                  }
                  @if (isSideFacePhoto) {
                    <h2
                      class="tw-font-body tw-text-black tw-text-center tw-text-500"
                      i18n="@@holdPhoneOnSide">Hold phone on side of <br>your face</h2>
                    }
                  </div>
                  @if (isFrontFacePhoto) {
                    <div *swiperSlide
                      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                      <div class="tw-relative">
                        @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
                          <img class="tw-rounded-5"
                            src="https://cdn.cureskin.com/app/img/hair_instruction_male_4.png"
                            alt="hair male instruction">
                        }
                        @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                          <img class="tw-rounded-5"
                            src="https://cdn.cureskin.com/app/img/hair_instruction_female_4.png"
                            alt="hair female instruction">
                        }
                        <div
                          class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-bottom-4">
                          <div
                            class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                            <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                            [iconName]="'close'"></cs-icon>
                          </div>
                          <div
                            class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                            <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                            [iconName]="'done'"></cs-icon>
                          </div>
                        </div>
                      </div>
                      @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
                        <h2
                          class="tw-font-body tw-text-black tw-text-center tw-text-500"
                          i18n="@@removeGlasses">
                                   Remove glasses</h2>
                      }
                      @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                        <h2
                          class="tw-font-body tw-text-black tw-text-center tw-text-500"
                          i18n="@@removeGlassesAndMakeup">
                                   Remove glasses <br>& makeup</h2>
                        }
                      </div>
                    }
                    @if (isSideFacePhoto) {
                      <div *swiperSlide
                        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                        <div class="tw-relative">
                          @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
                            <img class="tw-rounded-5"
                              src="https://cdn.cureskin.com/app/img/face_side_instruction_male_2.png"
                              alt="fece side instruction">
                          }
                          @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                            <img class="tw-rounded-5"
                              src="https://cdn.cureskin.com/app/img/face_side_instruction_female_2.png"
                              alt="face female side instruction">
                          }
                          <div
                            class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-top-4">
                            <div
                              class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                              <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                              [iconName]="'close'"></cs-icon>
                            </div>
                            <div
                              class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                              <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                              [iconName]="'done'"></cs-icon>
                            </div>
                          </div>
                        </div>
                        @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
                          <h2
                            class="tw-font-body tw-text-black tw-text-center tw-text-500"
                            i18n="@@ensureNaturalLight">
                                   Ensure natural light <br>for clear face detection</h2>
                          }
                          @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                            <h2
                              class="tw-font-body tw-text-black tw-text-center tw-text-500"
                              i18n="@@pullHairBack">
                                   Pull your hair back, <br>ensure natural lighting</h2>
                            }
                          </div>
                        }
                        @if (isFrontFacePhoto) {
                          <div *swiperSlide
                            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                            @if (user?.get('Gender') === appConfig.Shared.Gender.MALE) {
                              <img class="tw-rounded-5"
                                src="https://cdn.cureskin.com/app/img/hair_instruction_male_3.png"
                                alt="hair instruction">
                            }
                            @if (user?.get('Gender') !== appConfig.Shared.Gender.MALE) {
                              <img class="tw-rounded-5"
                                src="https://cdn.cureskin.com/app/img/hair_instruction_female_3.png"
                                alt="hair instruction">
                            }
                            <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500"
                              i18n="@@fitYourFaceInTheOval">
                                   Fit your face in <br>the oval</h2>
                            </div>
                          }
                        </swiper>
                      </section>
                      <footer
                        class="tw-fixed tw-bottom-0 tw-right-0 tw-left-0 tw-h-[160px] tw-flex tw-flex-col tw-gap-4 tw-px-6 tw-py-7">
                        @if (showFaceNextCta()) {
                          <button csButton="outlined"
                            type="button"
                            class="tw-w-full"
                            (click)="slider?.swiperRef.slideNext()"
                            i18n="@@next">Next
               </button>
                        }
                        @if (showFaceContinueCta()) {
                          <button csButton
                            type="button"
                            i18n="@@continue"
                            class="tw-w-full"
                          (click)="takePhoto()">Continue</button>
                        }
                        <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-500 tw-mb-0.5"
                          [iconName]="'lock-solid'"></cs-icon>
                          <span class="tw-font-body tw-text-100 tw-text-gray-500"
                          i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
                        </div>
                      </footer>
                    </main>
                  }

                  <file-picker (onFileChange)="uploadImageFromNativeCamera($event)"
                  capture="user"></file-picker>
